import WithUsersAndTeamsDataFetching from '../utils/WithUsersAndTeamsDataFetching';
import UsersAndTeamsAssetAccessPanel from './UsersAndTeamsAssetAccessPanel';
export default WithUsersAndTeamsDataFetching(UsersAndTeamsAssetAccessPanel);